/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

export default $ => css`
  .uweentity-history-list {
    .hist-timeline {
      display: flex;
      flex-direction: column;
      padding: 8px 16px;
    }

    .hist-entry {
      display: flex;
      gap: 10px;
      padding-bottom: 0;
    }

    .hist-indicator {
      display: flex;
      flex-direction: column;
      align-items: center;
      flex-shrink: 0;
      width: 14px;
    }

    .hist-dot {
      width: 12px;
      height: 12px;
      border-radius: 50%;
      background: ${$.primaryMain};
      border: 2px solid ${$.white};
      box-shadow: 0 0 0 2px ${$.primaryMain};
      flex-shrink: 0;
      margin-top: 3px;
    }

    .hist-line {
      width: 2px;
      flex: 1;
      min-height: 12px;
      background: ${$.gray200};
      margin: 4px 0;
    }

    .hist-body {
      flex: 1;
      min-width: 0;
      padding-bottom: 14px;
    }

    .hist-meta {
      display: flex;
      align-items: baseline;
      justify-content: space-between;
      gap: 6px;
      margin-bottom: 2px;
    }

    .hist-date {
      font-size: 10px;
      font-weight: 700;
      color: ${$.gray500};
      white-space: nowrap;
      flex-shrink: 0;
    }

    .hist-user {
      font-size: 11px;
      color: ${$.primaryMain};
      font-weight: 600;
      text-align: right;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .hist-action {
      font-size: 13px;
      font-weight: 500;
      color: ${$.gray800};
      line-height: 1.3;
    }

    .hist-option {
      font-size: 12px;
      color: ${$.gray600};
      margin-top: 3px;
    }

    .hist-reason {
      margin-top: 5px;
      padding: 5px 8px;
      background: ${$.gray100};
      border-left: 3px solid ${$.gray400};
      font-size: 12px;
      color: ${$.gray700};
      border-radius: 0 4px 4px 0;
      line-height: 1.4;
    }
  }
`;
